const getCordova = () => window.cordova;

const isChromeExtension = () => window.location.protocol === "chrome-extension:";

const isNativeApp = () => Boolean(getCordova());

const getPlatformId = () => {
  const cordova = getCordova();
  return cordova ? cordova.platformId : "website";
};

const isIOS = () => isNativeApp() && getPlatformId() !== "android";

export { getCordova, getPlatformId, isChromeExtension, isIOS, isNativeApp };
